import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate, useParams,useLocation } from 'react-router-dom';
import '../../styles/sidebar/sidebar.css';
import { corporateUrl } from '../../config/config';
import baseUrl from '../../config/config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComputer, faLaptopMedical,faChalkboardUser,faRightFromBracket, faHistory } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-tooltip';
import api from '../../api/api';

const Sidebar = ({activeIndex, setActiveIndex}) => {
    // const navigate = useNavigate();
    const location = useLocation();
    const [sidebarVisible, setSidebarVisible] = useState(false);
    const [userDetails, setDetails] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [isExpanded, setIsExpanded] = useState(true);
    const [id, setId] = useState("");
    //const [activeIndex,setActiveIndex] = useState(1);
    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const fetchDetails = async () => {

        try {
            const token = localStorage.getItem('token'); //retrive the token from the local storage
            const response = await api.get(`${corporateUrl}/api/user-details/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
                },
            });
            setDetails(response.data);
            console.log(response.data)
        } catch (error) {
            console.error('Error fetching details:', error);
        }
    };

    const navigate = (id) => {
        setActiveIndex(id);
    }

    useEffect(() => {
        setTimeout(() => {
            setId(localStorage.getItem('user_id'))
        }, 1000)

        fetchDetails();

    }, [id]);


    const toggleSidebar = () => {
        setSidebarVisible(!sidebarVisible);
        setIsOpen(!isOpen);
    };

    const handleLogout = async () => {
        try {
            // Remove token and user_id from localStorage
            localStorage.removeItem('token');
            localStorage.removeItem('user_id');
            localStorage.removeItem('authenticated')
            window.close()
            const response = await api.post(`${baseUrl}/api/logout`, { id: id });
        } catch (error) {
            console.error('Error logging out:', error);
        }
    };

    return (
        <div className="sid_nav_main">
            {(
            <button className="expand_button" onClick={toggleExpand}>
                {!isExpanded ? `☰` : ` X`}
            </button>
            )}
            <div className={`sidebar visible ${isExpanded ? 'expanded' : 'collapsed'}`}>

                <div className="sidebar visible">
                    <div>
                        <Link to={`/assigned-assets/${id}`} >
                            {/* <img src='/images/hom.png' alt="Home Icon" className="sidebar-icon" /> */}
                            <FontAwesomeIcon data-tooltip-id="tool-tip-nav1" data-tooltip-content="Assets Overview" className={location.pathname == `/assigned-assets/${id}`? "font-icons active" : "font-icons"} icon={faChalkboardUser} onClick={() => navigate(1)}/>
                            <Tooltip id="tool-tip-nav1" className="nav-tooltip" border="1px solid #5c2680"/>
                        </Link>
                        
                        {userDetails && userDetails.access_type === 1 && (
                            <>
                                <Link to={`/create-asset/${id}`} >
                                    <FontAwesomeIcon data-tooltip-id="tool-tip-nav2" data-tooltip-content="Add Asset" className={location.pathname ==`/create-asset/${id}` ? "font-icons active" : "font-icons"} icon={faLaptopMedical} onClick={() => navigate(2)}/>
                                    <Tooltip id="tool-tip-nav2" className="nav-tooltip"border="1px solid #5c2680" />
                                </Link>
                            </>
                        )}
                        {userDetails && (userDetails.access_type === 1 || userDetails.access_type === 3) && (
                            <>
                                <Link to={`/all-assets`} >
                                    <FontAwesomeIcon data-tooltip-id="tool-tip-nav3" data-tooltip-content="All Assets" className={location.pathname ==`/all-assets` ? "font-icons active" : "font-icons"} icon={faComputer} onClick={() => navigate(3)}/>
                                    <Tooltip id="tool-tip-nav3" className="nav-tooltip" border="1px solid #5c2680"/>
                                </Link>
                                <Link to={`/activities`} >
                                    <FontAwesomeIcon data-tooltip-id="tool-tip-nav4" data-tooltip-content="Activity Log" className={location.pathname ==`/activities`? "font-icons active" : "font-icons"} icon={faHistory} onClick={() => navigate(4)}/>
                                    <Tooltip id="tool-tip-nav4" className="nav-tooltip" border="1px solid #5c2680"/>
                                </Link>
                            </>
                        )}
                            
                    </div>
                    <div className="logout">
                        <Link to="/login" onClick={handleLogout}>
                            <FontAwesomeIcon data-tooltip-id="tool-tip-nav-logout" data-tooltip-content="Logout" className='font-icons fa-light' icon={faRightFromBracket} />
                            <Tooltip id="tool-tip-nav-logout" className="nav-tooltip" border="1px solid #5c2680"/>
                        </Link>
                    </div>
                    <div>

                    </div>
                </div>
            </div>
        </div>
    )
};

export default Sidebar;
